<template>
  <SmallCardModal>
    <template #body>
      <ion-button
        fill="outline"
        expand="block"
        size="default"
        color="primary"
        class="text-weight-bold"
        @click="handleClearFilters()"
      >
        {{ t('search.clearFilters') }}
      </ion-button>
      <ion-button
        expand="block"
        color="primary"
        shape="round"
        @click="handleApplyFilters"
        :disabled="!!getDisabled"
        >{{ t('search.applyPreferences') }}</ion-button
      >
    </template>
  </SmallCardModal>

  <div v-if="!isLoading" class="content-modal bg-white">
    <ion-row class="ion-justify-content-between ion-align-items-baseline">
      <h3 class="h3 blue-darker bold-normal font-lg">{{ t('search.personalize') }}</h3>

      <!--       <ion-col size="12" class="ion-no-padding mt-xs">
        <h4 class="h4 bold-medium mt-16 mb-8">{{ t('search.accomType') }}</h4>
      </ion-col>
      <ion-col size="12" class="ion-no-padding">
        <ion-list class="bg-white ion-no-padding">
          <ion-chip
            v-for="type in propertyTypeOptions"
            @click="filters.PropertyTypeId = type.id"
            color="primary"
            :outline="true"
            class="form-control chips"
            :class="{ active: filters.PropertyTypeId === type.id }"
            :key="type.id"
          >
            <ion-label>{{ type[`name_${language}` as keyof typeof type] }}</ion-label>
          </ion-chip>
        </ion-list>
      </ion-col> -->

      <ion-col size="12" class="mt-xs ion-no-padding">
        <h4 class="h4 bold-medium mt-16 mb-16">{{ t('search.priceRange') }}</h4>
      </ion-col>
      <ion-col size="6" class="ion-no-padding">
        <ion-input
          v-model="filters.minPrice"
          type="number"
          :label="t('search.minPrice')"
          :placeholder="t('search.minPrice')"
          mode="md"
          shape="round"
          class="custom-field"
          label-placement="stacked"
          fill="outline"
          :min="0"
        >
        </ion-input>
      </ion-col>
      <ion-col size="6">
        <ion-input
          v-model="filters.maxPrice"
          type="number"
          :label="t('search.maxPrice')"
          :placeholder="t('search.maxPrice')"
          mode="md"
          shape="round"
          class="custom-field"
          label-placement="stacked"
          fill="outline"
          :min="0"
        >
        </ion-input>
      </ion-col>
    </ion-row>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue';
  import { IonCol, IonRow, IonButton, IonInput } from '@ionic/vue';
  import SmallCardModal from './announcement/SmallCardModal.vue';
  import { useElasticStore } from '@/stores/elastic-store';
  import { storeToRefs } from 'pinia';
  import { useI18n } from 'vue-i18n';
  import { useFilters } from '@/composables/useFilters';

  defineProps({
    language: {
      type: String,
      required: false,
      default: 'en',
    },
  });

  const emit = defineEmits(['close']);
  const isLoading = ref(true);
  const { t } = useI18n();

  const { selectedFilters, filters } = storeToRefs(useElasticStore());
  const { getPropertyElements } = useElasticStore();

  const { applyFilters, clearFilters } = useFilters();

  const getDisabled = computed(() => {
    const { minPrice, maxPrice } = filters.value;

    return (minPrice && minPrice <= 0) || (maxPrice && maxPrice <= 0);
  });

  const handleApplyFilters = async () => {
    await applyFilters();
    emit('close');
  };

  const handleClearFilters = async () => {
    await clearFilters(true);
    await applyFilters();
    emit('close');
  };

  const setInitialData = () => {
    filters.value.minPrice = selectedFilters.value.mappedFilters.minPrice
      ? Number(selectedFilters.value.mappedFilters.minPrice)
      : undefined;

    filters.value.maxPrice = selectedFilters.value.mappedFilters.maxPrice
      ? Number(selectedFilters.value.mappedFilters.maxPrice)
      : undefined;
    /*     filters.value.PropertyTypeId = selectedFilters.value.mappedFilters.PropertyTypeId
      ? Number(selectedFilters.value.mappedFilters.PropertyTypeId)
      : -1; */

    isLoading.value = false;
  };

  onMounted(() => {
    setInitialData();
    getPropertyElements();
  });
</script>

<style scoped>
  .content-modal {
    padding: 24px 15px 150px 15px;
    height: 100%;
    overflow: auto;
  }

  .chips {
    padding: 7px 15px;
  }

  .results {
    position: absolute;
    z-index: 99;
    width: 90%;
  }
</style>
